<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Acesso Rápido</h3>
        </div>
      </div>
      <div v-if="cardsRegister.length == 0 && cardsQuery.length == 0 && cardsDashboard.length == 0">
        <h5 class="page-title"></h5>
        <div class="row">
          <d-col
            md="12"
            lg="12"
            class="mb-12"
          >
            <cards
              id="card-1"
              value="Você não possui permissão para acessar esses recursos :("
              addClass="border-black"
            />
          </d-col>
        </div>
      </div>
      <div v-if="cardsRegister.length > 0">
        <h5 class="page-title">Cadastro</h5>
        <div class="row">
          <d-col
            v-for="(card, index) in cardsRegister"
            :key="index"
            md="6"
            lg="3"
            class="mb-4"
          >
            <cards
              :id="`card-${index}`"
              :link="card.link"
              :label="card.label"
              :value="card.subtitle"
              :addClass="card.addClass"
            />
          </d-col>
        </div>
      </div>
      <div v-if="cardsQuery.length > 0">
        <h5 class="page-title">Consulta</h5>
        <div class="row">
          <d-col
            v-for="(card, index) in cardsQuery"
            :key="index"
            md="6"
            lg="3"
            class="mb-4"
          >
            <cards
              :id="`card-${index}`"
              :link="card.link"
              :label="card.label"
              :value="card.subtitle"
              :addClass="card.addClass"
            />
          </d-col>
        </div>
      </div>
      <div v-if="cardsDashboard.length > 0">
        <h5 class="page-title">Dashboard</h5>
        <div class="row">
          <d-col
            v-for="(card, index) in cardsDashboard"
            :key="index"
            md="6"
            lg="3"
            class="mb-4"
          >
            <cards
              :id="`card-${index}`"
              :link="card.link"
              :label="card.label"
              :value="card.subtitle"
              :addClass="card.addClass"
            />
          </d-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cards from "@/components/common/cards";

export default {
  name: "access-quick",
  components: {
    cards,
  },
  data: function () {
    return {
      cardsRegister: [
        {
          code: "1",
          label: "Cadastrar",
          subtitle: "Cliente",
          addClass: "border-lightskyblue",
          controller: "Merchant",
          action: "Add",
          link: {
            component: "merchants",
            query: { open: true },
          },
        },
        {
          code: "2",
          label: "Cadastrar",
          subtitle: "Parceiro",
          controller: "Partner",
          action: "Add",
          addClass: "border-lightskyblue",
          link: {
            component: "partners",
            query: { open: true },
          },
        },
        {
          code: "3",
          label: "Templates de",
          subtitle: "E-mail",
          controller: "TemplateEmail",
          action: "List",
          addClass: "border-lightskyblue",
          link: {
            component: "template-email",
            params: { idTemplateEmail: 0 },
            query: { isSeeing: false },
          },
        },
      ],
      cardsQuery: [
        {
          code: "1",
          label: "",
          subtitle: "Pagamentos",
          controller: "CheckingAccount",
          action: "ListMerchant",
          addClass: "border-lightsteelblue",
          link: {
            component: "payments",
          },
        },
        {
          code: "2",
          label: "Comissões dos",
          subtitle: "Parceiros",
          controller: "CheckingAccountPartner",
          action: "List",
          addClass: "border-lightsteelblue",
          link: {
            component: "partner-commissions",
          },
        },
        {
          code: "3",
          label: "",
          subtitle: "Chargebacks",
          controller: "Chargeback",
          action: "List",
          addClass: "border-lightsteelblue",
          link: {
            component: "chargeback",
          },
        },
        {
          code: "4",
          label: "Desempenho dos",
          subtitle: "Clientes",
          controller: "ClientMaintenance",
          action: "List",
          addClass: "border-lightsteelblue",
          link: {
            component: "merchant-metrics",
          },
        },
      ],
      cardsDashboard: [
        {
          code: "1",
          label: "Dashboard de ",
          subtitle: "Negócio",
          controller: "InternalDashboard",
          action: "GetBusiness",
          addClass: "border-steelblue",
          link: {
            component: "business-dashboard",
          },
        },
        {
          code: "2",
          label: "Dashboard",
          subtitle: "Financeiro",
          controller: "Profit",
          action: "Get",
          addClass: "border-steelblue",
          link: {
            component: "financial-dashboard",
          },
        },
        {
          code: "3",
          label: "Dashboard",
          subtitle: "Chargeback",
          controller: "Chargeback",
          action: "GetDashboard",
          addClass: "border-steelblue",
          link: {
            component: "chargebackDashboard",
          },
        },
        {
          code: "4",
          label: "Dashboard de",
          subtitle: "Marketplace",
          controller: "InternalDashboard",
          action: "GetMarketplace",
          addClass: "border-steelblue",
          link: {
            component: "marketplace-dashboard",
          },
        },
      ],
    };
  },
  created() {},
  destroyed() {},
  computed: {},
  watch: {},
  mounted() {
    this.IsAuthorizeCards();
  },
  methods: {
    IsAuthorizeCards: function () {
      this.IsAuthorize(this.cardsRegister);
      this.IsAuthorize(this.cardsQuery);
      this.IsAuthorize(this.cardsDashboard);
    },
    IsAuthorize: function (cards) {
      let cardsSplice = [];
      cards.forEach((elm) => {
        if (!this.$isAuthorize(elm.controller, elm.action))
          cardsSplice.push(elm);
      });
      cardsSplice.forEach((elm) => {
        let index = cards
          .map((e) => {
            return e.code;
          })
          .indexOf(elm.code);

        if (index > -1) {
          cards.splice(index, 1);
        }
      });
    },
  },
};
</script>

<style scoped>
.access-quick {
  padding-left: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/accessQuick.vue